module.exports = __webpack_public_path__ + "assets/plesk.d115b46b.svg";